import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isBookingsFirstName(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.BOOKINGS_FIRST_NAME && typeof label === 'string' && typeof value === 'string';
}
function _formatBookingsFirstName(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatBookingsFirstName(submission) {
  if (isBookingsFirstName(submission)) {
    return _formatBookingsFirstName(submission);
  }
  return undefined;
}
//# sourceMappingURL=bookings-first-name-preview.js.map